import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { CustomerFragment } from '@/helpers/api/fragments'

const output = `
    ...Customer
`

const fragments = gql`
  ${CustomerFragment}
`

const allowedFields = [
  'customer_number',
  'legal_name',
  'vat_number',
  'send_digital_invoice',
  'billing_email',
  'eu_vat_exempt',
  'default_language',
  'is_archived',
  'primary_phone',
  'primary_email',
  'payment_term_id',
  'use_structured_reference',
  'billing_address_id',
  'old_id',
  'vat_number_valid',
  'vat_number_last_checked_at'
]

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'account',
    defaultPageSize: 25,
    defaultOrderBy: [
      { rating: 'desc' },
      { number: 'asc' },
      { company_name: 'asc' }
    ],
    defaultSearchBy: ['company_name', 'number', 'vat_number'],
    defaultFilters: [
      { is_archived: { _eq: false } },
      { is_customer: { _eq: true } }
    ],
    defaultOutput: output,
    defaultFragments: fragments,
    uniqueFields: ['number', 'vat_number'],
    allowedFields
  })

  return {
    ...service,
    nextNumber: async () => {
      const query = gql`
        query {
          customer_aggregate {
            aggregate {
              max {
                customer_number
              }
            }
          }
        }
      `
      try {
        const result = await client.query({
          fetchPolicy: 'network-only',
          query
        })
        let max = result.data
          ? parseInt(
              result.data.customer_aggregate.aggregate.max.customer_number
            )
          : null
        return max ? `${max + 1}` : '5000'
      } catch (error) {
        throw error
      }
    },
    validateVatNumber: async payload => {
      const { vat_number, customer_id } = payload
      const query = gql`
        query {
          validate_vatnumber(vat_number: "${vat_number}", customer_id: "${customer_id}") {
            company_address
            company_name
            country_code
            format_valid
            vat_number
            valid
          }
        }
      `
      try {
        let { data } = await client.query({
          fetchPolicy: 'network-only',
          query
        })
        return data.validate_vatnumber
      } catch (error) {
        throw error
      }
    }
  }
}
